// extracted by mini-css-extract-plugin
export default {"container":"Divider_container__zfZBm","title":"Divider_title__+v1f9","horizontalLine":"Divider_horizontalLine__vTPdt","count":"Divider_count__e+SY7"};